import { Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AdminGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {

    const role = localStorage.getItem('Role');

    if (role === 'admin') {
      return true;
    }

    return this.router.createUrlTree(['/organiser/dashboard']);

  }

}
